// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"452":"0d1ae2ca","465":"6ae161cd"}[chunkId] + ".chunk.css";
};